import { Field } from '../../../Presentaciones/components/DynamicData';

export const generateContractFields = ({ contrato, t }: any): Field[] => [
    {
        campo: t('headerContract.agencyName'),
        valor: contrato?.nombre || 'N/A',
        gridSize: { xs: 12, sm: 6, md: 4, lg: 2 }
    },
    {
        campo: t('headerContract.agencyContractCIUUNumber'),
        valor: contrato?.cuit || 'N/A',
        gridSize: { xs: 12, sm: 6, md: 4, lg: 2 }
    },
    {
        campo: t('headerContract.agencyContractNumber'),
        valor: contrato?.nroContrato || 'N/A',
        gridSize: { xs: 12, sm: 6, md: 4, lg: 2 }
    },
    {
        campo: t('headerContract.establishmentCIIU'),
        valor: contrato?.ciiuRevision4?.codigo || 'N/A',
        gridSize: { xs: 12, sm: 6, md: 4, lg: 2 }
    },
    {
        campo: t('headerContract.establishmentEmail'),
        valor: contrato?.email || 'N/A',
        gridSize: { xs: 12, sm: 6, md: 4, lg: 2 }
    },
    {
        campo: t('headerContract.establishmentPhone'),
        valor: contrato?.telefono || 'N/A',
        gridSize: { xs: 12, sm: 6, md: 4, lg: 2 }
    }
];
